// extracted by mini-css-extract-plugin
export default {"inputAuth":"auth_inputAuth__zDAyk"};